import React, { useContext } from "react";
import { NavLink, Link } from "react-router-dom";
import { userRoles } from "../services/constant";
import { clearLocalStorage } from "../services/userStorage";
import { useNavigate } from "react-router";
import UserContext from "../components/UserContext";
import { useToast } from "../components/ToastContext";
import '../assets/css/AppMenu.css';

function AppMenu() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const userContext = useContext(UserContext);

  const user = JSON.parse(localStorage.getItem("user")) || {};
  const userRole = user.role || 2;

  const getRole = (role) => {
    const roleData = userRoles.find((item) => item.value === role);
    return roleData ? roleData.name : "";
  };

  return (
    <>
      <div className="app-menu-container">
        <NavLink to={"/home"}>Home</NavLink> &nbsp; &nbsp;
        <NavLink to={"/site"}>Sites</NavLink> &nbsp; &nbsp;
        <NavLink to={"/details"}>Details</NavLink> &nbsp; &nbsp;
        <NavLink to={"/memory"}>Memory</NavLink> &nbsp; &nbsp;

        {userRole === 1 && (
          <>
            <NavLink to="/user">Users</NavLink> &nbsp; &nbsp;
          </>
        )}

        <Link
          onClick={() => {
            showToast("Successfully logged out", "success", 500);

            setTimeout(() => {
              clearLocalStorage();
              userContext.doLogout();
              navigate("/login");
            }, 500);
          }}
        >
          Logout
        </Link>

        {user.name && (
          <span className="me-3 float-end h5">
            {user.name} ({getRole(userRole)}) &nbsp;
          </span>
        )}
      </div>
      <hr className="p-0 my-2" />
    </>
  );
}

export default AppMenu;
